export default "__VITE_ASSET__32e8e0fe__"